import { useState, useEffect } from "react";

// Single radial ripple on viewport entry, not looping (per Section 04).
// Depends on the `resourcePulse` keyframes defined in global.css.
export default function ResourcePulse({ color, visible }) {
  const [pulsed, setPulsed] = useState(false);
  useEffect(() => { if (visible && !pulsed) setPulsed(true); }, [visible, pulsed]);
  if (!pulsed) return null;
  return (
    <div
      style={{
        position: "absolute", top: "50%", left: "50%",
        width: 120, height: 120, marginTop: -60, marginLeft: -60,
        borderRadius: "50%", border: `1.5px solid ${color}`,
        opacity: 0, transform: "scale(0)",
        animation: "resourcePulse 700ms cubic-bezier(0.0, 0.0, 0.2, 1.0) forwards",
        pointerEvents: "none",
      }}
    />
  );
}
